import http from '@http';
import { origin } from 'endpoints';

export default urlResponse => http.get({ url: '{protocol}://' + origin + urlResponse });
